// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cAqS","placeholdersHeader":"styles_placeholdersHeader__19AtK","editorStyle":"styles_editorStyle__Bx0Bb","placeholdersBox":"styles_placeholdersBox__3gob8"};